var map = {
	"./assassin.png": "c813",
	"./merlin-morgana.png": "9a3a",
	"./merlin.png": "7719",
	"./minion-1.png": "4a96",
	"./minion-2.png": "61f8",
	"./minion-3.png": "7edd",
	"./mordred.png": "d14e",
	"./morgana.png": "3ffd",
	"./oberon.png": "5dcb",
	"./percival.png": "96da",
	"./servant-1.png": "368d",
	"./servant-2.png": "200c",
	"./servant-3.png": "726c",
	"./servant-4.png": "dccb",
	"./servant-5.png": "fcb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbdb";